import $ from 'jquery';

/**
 * selects the input's value on focus
 */
$.fn.extend({
    selectOnFocus: function () {
        return this.each((index, element) => {
            $(element).focus(() => {
                $(element).select();
            });
        });
    }
});


// WEBPACK FOOTER //
// ./jquery/jquery.selectOnFocus.js